/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SharedserviceMelcoModelsCustomWarning,
    SharedserviceMelcoModelsCustomWarningFromJSON,
    SharedserviceMelcoModelsCustomWarningFromJSONTyped,
    SharedserviceMelcoModelsCustomWarningToJSON,
    SharedserviceMelcoModelsDesignCollection,
    SharedserviceMelcoModelsDesignCollectionFromJSON,
    SharedserviceMelcoModelsDesignCollectionFromJSONTyped,
    SharedserviceMelcoModelsDesignCollectionToJSON,
} from './';

/**
 * 
 * @export
 * @interface SharedserviceMelcoModelsGenericList1MelcoModelsDesignCollection
 */
export interface SharedserviceMelcoModelsGenericList1MelcoModelsDesignCollection {
    /**
     * 
     * @type {Array<SharedserviceMelcoModelsDesignCollection>}
     * @memberof SharedserviceMelcoModelsGenericList1MelcoModelsDesignCollection
     */
    list: Array<SharedserviceMelcoModelsDesignCollection>;
    /**
     * 
     * @type {Array<SharedserviceMelcoModelsCustomWarning>}
     * @memberof SharedserviceMelcoModelsGenericList1MelcoModelsDesignCollection
     */
    warning_list?: Array<SharedserviceMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof SharedserviceMelcoModelsGenericList1MelcoModelsDesignCollection
     */
    total: number;
}

export function SharedserviceMelcoModelsGenericList1MelcoModelsDesignCollectionFromJSON(json: any): SharedserviceMelcoModelsGenericList1MelcoModelsDesignCollection {
    return SharedserviceMelcoModelsGenericList1MelcoModelsDesignCollectionFromJSONTyped(json, false);
}

export function SharedserviceMelcoModelsGenericList1MelcoModelsDesignCollectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): SharedserviceMelcoModelsGenericList1MelcoModelsDesignCollection {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(SharedserviceMelcoModelsDesignCollectionFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(SharedserviceMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function SharedserviceMelcoModelsGenericList1MelcoModelsDesignCollectionToJSON(value?: SharedserviceMelcoModelsGenericList1MelcoModelsDesignCollection | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(SharedserviceMelcoModelsDesignCollectionToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(SharedserviceMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


